"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.from_present = void 0;
const Exp = __importStar(require("../exp"));
const inspect_1 = require("../utils/inspect");
function from_present(present) {
    if (typeof present === "string")
        return from_string(present);
    else
        return from_object(present);
}
exports.from_present = from_present;
function from_string(str) {
    if (str.startsWith('"') && str.endsWith('"')) {
        return Exp.str(JSON.parse(str));
    }
    else {
        return Exp.v(str);
    }
}
function from_object(obj) {
    if (obj.hasOwnProperty("$fn")) {
        const [name, ret] = obj["$fn"];
        return Exp.fn(name, Exp.from_present(ret));
    }
    else if (obj.hasOwnProperty("$ap")) {
        const [target, ...args] = obj["$ap"];
        return Exp.ap(Exp.from_present(target), args.map(Exp.from_present));
    }
    else if (obj.hasOwnProperty("$pattern")) {
        const [label, pattern, flags] = obj["$pattern"];
        if (pattern !== undefined) {
            return Exp.pattern(label, new RegExp(pattern, flags));
        }
        else {
            return Exp.pattern(label, new RegExp(".*", flags));
        }
    }
    else if (obj.hasOwnProperty("$grammar")) {
        return build_grammar(obj["$grammar"]);
    }
    else {
        throw new Error(`Unknown object: ${(0, inspect_1.inspect)(obj)}`);
    }
}
function build_grammar(obj) {
    let name = undefined;
    let choices = new Map();
    for (const [key, parts] of Object.entries(obj)) {
        const [grammar_name, choice_name] = key.split(":");
        if (name && name !== grammar_name) {
            throw new Error(`ambiguous grammar name.\n` +
                `new name: ${grammar_name}\n` +
                `old name: ${name}\n`);
        }
        else {
            name = grammar_name;
        }
        choices.set(choice_name, parts.map(build_part));
    }
    if (name) {
        return Exp.grammar(name, choices);
    }
    else {
        throw new Error(`can not find grammar name from obj: ${(0, inspect_1.inspect)(obj)}`);
    }
}
function build_part(part) {
    const result = parse_bind(part);
    if (result) {
        const [name, present] = result;
        // NOTE a string in bind is special, it is always Exp.v -- instead of Exp.str.
        const value = typeof present === "string" ? Exp.v(present) : Exp.from_present(present);
        return { name, value };
    }
    else {
        return { value: Exp.from_present(part) };
    }
}
function parse_bind(present) {
    if (typeof present === "string")
        return null;
    if (present instanceof Array)
        return null;
    const keys = Object.keys(present);
    if (keys.length !== 1)
        return null;
    const key = keys[0];
    if (key.startsWith("$"))
        return null;
    if (key.includes(":"))
        return null;
    return [key, present[key]];
}
//# sourceMappingURL=exp-from-present.js.map